/**
 * Trek stay option names from CMS may already end with "Sharing"; avoid "Triple Sharing Sharing".
 * Legacy camps without a custom stay list use id `quad` — shown as Group Sharing (not Quad).
 */
function normalizeStayOptionId(raw) {
  if (raw == null) return '';
  return String(raw).trim();
}

function legacyStayLabel(stayId) {
  const id = normalizeStayOptionId(stayId).toLowerCase();
  if (id === 'quad') return 'Group Sharing';
  if (id === 'triple') return 'Triple Sharing';
  if (id === 'double') return 'Double Sharing';
  return '';
}

export function formatStayOptionLabel(nameFromTrek, stayOption) {
  const raw = nameFromTrek != null ? String(nameFromTrek).trim() : '';
  if (raw) {
    const fixed = raw.replace(/^Tripple\b/i, 'Triple');
    if (/sharing\s*$/i.test(fixed)) return fixed;
    return `${fixed} Sharing`;
  }
  const legacy = legacyStayLabel(stayOption);
  if (legacy) return legacy;
  const id = normalizeStayOptionId(stayOption);
  return id || '—';
}

/** Human-readable stay for admin tables / modals. */
export function formatBookingStayDisplay(booking) {
  const trek = booking?.batch?.trek;
  const stayOptionsList =
    Array.isArray(trek?.stayOptions) && trek.stayOptions.length > 0 ? trek.stayOptions : [];
  const raw = booking?.stayOption ?? booking?.stay_option;
  let stayId = normalizeStayOptionId(raw);
  if (!stayId) {
    if (stayOptionsList.length > 0) {
      stayId = normalizeStayOptionId(stayOptionsList[0]?.id);
    } else {
      stayId = 'quad';
    }
  }
  if (!stayId) return '—';
  const hit = stayOptionsList.find(
    (o) => normalizeStayOptionId(o.id).toLowerCase() === stayId.toLowerCase()
  );
  return formatStayOptionLabel(hit?.name, stayId);
}
